import React from 'react'
import ReactDOM from 'react-dom'
import './bootstrap.4.4.1.css'
import './index.scss'
import App from './App'

import 'overlayscrollbars/css/OverlayScrollbars.css'

ReactDOM.render(<App />, document.getElementById('root'))
